import { AxiosError, AxiosResponse } from 'axios';

import { RESPONSE_CODES } from '../constants/responseCodes.constants';
import { api } from '../http';
import { DefaultCallback, DefaultRes } from '../types';
import { ScheduledReportTypes } from '../types/scheduledReport.types';

const uri = 'report-schedules';

// Stateless CRUD — schedules are few per subscription and only the
// management screens consume them, so there's no redux model.
export class ScheduledReportService {
    public static async fetchAll(
        callback?: DefaultCallback,
    ): Promise<ScheduledReportTypes.Model[]> {
        try {
            const { data: { result, isValid, message } } = await api.get<
                DefaultRes<ScheduledReportTypes.Model[]>,
                AxiosResponse<DefaultRes<ScheduledReportTypes.Model[]>>
            >(`/${uri}`);
            if (callback) callback(isValid, RESPONSE_CODES[message]);
            return result ?? [];
        } catch (error: any) {
            const code = (error as AxiosError<DefaultRes<unknown>>).response?.data?.message;
            if (callback) callback(false, RESPONSE_CODES[code!] || String(error));
            return [];
        }
    }

    public static async create(
        payload: ScheduledReportTypes.CreateParams,
        callback: DefaultCallback,
    ) {
        try {
            const { data: { isValid, message } } = await api.post<
                DefaultRes<ScheduledReportTypes.Model>,
                AxiosResponse<DefaultRes<ScheduledReportTypes.Model>>
            >(`/${uri}`, payload);
            return callback(isValid, isValid ? 'Report schedule created' : RESPONSE_CODES[message]);
        } catch (error: any) {
            const code = (error as AxiosError<DefaultRes<unknown>>).response?.data?.message;
            return callback(false, RESPONSE_CODES[code!] || String(error));
        }
    }

    public static async update(
        id: string,
        payload: ScheduledReportTypes.UpdateParams,
        callback: DefaultCallback,
    ) {
        try {
            const { data: { isValid, message } } = await api.put<
                DefaultRes<ScheduledReportTypes.Model>,
                AxiosResponse<DefaultRes<ScheduledReportTypes.Model>>
            >(`/${uri}/${id}`, payload);
            return callback(isValid, isValid ? 'Report schedule updated' : RESPONSE_CODES[message]);
        } catch (error: any) {
            const code = (error as AxiosError<DefaultRes<unknown>>).response?.data?.message;
            return callback(false, RESPONSE_CODES[code!] || String(error));
        }
    }

    public static async destroy(id: string, callback: DefaultCallback) {
        try {
            const { data: { isValid, message } } = await api.delete<
                DefaultRes<unknown>,
                AxiosResponse<DefaultRes<unknown>>
            >(`/${uri}/${id}`);
            return callback(isValid, isValid ? 'Report schedule deleted' : RESPONSE_CODES[message]);
        } catch (error: any) {
            const code = (error as AxiosError<DefaultRes<unknown>>).response?.data?.message;
            return callback(false, RESPONSE_CODES[code!] || String(error));
        }
    }
}
